import { Button, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import { useTheme } from '../ThemeProvider';

type DarkModeToggleProps = {
  className?: string;
  variant?: 'primary' | 'default' | 'destructive' | 'minimal' | 'picker';
  size?: 'small' | 'large' | 'medium';
};

export function DarkModeToggle({ className = '', variant = 'minimal', size = 'medium' }: DarkModeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const tooltipText = `Switch to ${theme === 'light' ? 'dark' : 'light'} mode`;

  return (
    <TooltipTrigger>
      <Button className={className} variant={variant} size={size} onClick={toggleTheme} aria-label={tooltipText}>
        {theme === 'light' ? '🌙' : '☀️'}
      </Button>
      <Tooltip placement="bottom" variant="popover">
        {tooltipText}
      </Tooltip>
    </TooltipTrigger>
  );
}
